import { useRef, useState } from "react";
import { loginFormFields } from "../constants/loginFormFields";
import { Button, TextInput } from "../../../components";
import { Link, useLocation } from "react-router-dom";
import { GAEventTrack } from "../../../utils/hooks/GA_events";
import { toast } from "react-toastify";
import { login } from "../../../redux/features/authSlice";
import authServiceMobile from "../../../firebase/authServiceMobile";
import { useDispatch, useSelector } from "react-redux";

const UserLogin = () => {
  const dispatch = useDispatch();
  const { userDetails, loading } = useSelector((state) => state.auth);
  const formRef = useRef();
  const [error, setError] = useState(null);

  const location = useLocation();
  const tabName = location.pathname.split("/")[2];
  const searchParams = new URLSearchParams(location.search);
  const isAiLab = searchParams.get("source") === "ai-lab";

  const handleLogin = async (email, password) => {
    try {
      await dispatch(login({ email, password })).unwrap();
    } catch (error) {
      throw new Error(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const formData = e.target;
    const email = formData.email.value;
    const password = formData.password.value;
    if (!email) {
      setError((prev) => ({
        ...prev,
        email: "Please enter a valid email id",
      }));
    }
    if (!password) {
      setError((prev) => ({
        ...prev,
        password: "Please enter a valid password",
      }));
    }
    if (!email || !password) return;
    //GA event tracking
    GAEventTrack({
      event: "login_submit",
      data: {
        email: email,
      },
    });
    try {
      if (tabName === "individual") {
        try {
          await authServiceMobile.login({ email, password });
        } catch (mobileErr) {
          const mobileErrMsg = mobileErr?.message || "Login failed.";
          toast.error(mobileErrMsg);
          if (
            mobileErrMsg === "No user found for the this email id." ||
            mobileErrMsg === "User not found"
          ) {
            setError((prev) => ({ ...prev, email: mobileErrMsg }));
          } else if (mobileErrMsg === "Invalid password.") {
            setError((prev) => ({ ...prev, password: mobileErrMsg }));
          } else {
            setError((prev) => ({ ...prev, other: mobileErrMsg }));
          }
          return; // stop if mobile login failed
        }
      }

      await handleLogin(email, password);

      //GA event tracking
      GAEventTrack({
        event: "loged_in",
        data: {
          email: email,
          uid: userDetails?.uid,
        },
      });
    } catch (error) {
      const errMsg = error?.message || "Login failed.";
      if (tabName === "individual") {
        try {
          await authServiceMobile.logout();
        } catch (_) {}
      }
      toast.error(errMsg);
      if (
        errMsg === "No user found for the this email id." ||
        errMsg === "User not found"
      ) {
        setError((prev) => ({ ...prev, email: errMsg }));
      } else if (errMsg === "Invalid password.") {
        setError((prev) => ({ ...prev, password: errMsg }));
      } else {
        console.log(error);
        setError((prev) => ({ ...prev, other: errMsg }));
      }
    }
  };

  return (
    <div className="form-data step-1">
      <h1>Sign In to your Account</h1>

      <form onSubmit={handleSubmit} className="w-full mt-10" ref={formRef}>
        {loginFormFields?.map(
          ({ name, label, type, required, placeholder }) => {
            return (
              <div key={name} className={`form-group`}>
                <label htmlFor={name}>
                  {label}
                  {required && <span> * </span>}
                </label>
                <TextInput
                  type={type}
                  placeholderText={placeholder}
                  inputName={name}
                  error={error?.[name]}
                />
                {/* {name === "password" && (
                  <div className="text-right">
                    <Link
                      to="forgotPassword"
                      className="text-[#009DFF] hover:text-[#009DFF] font-bold"
                      onClick={() =>
                        GAEventTrack({ event: "forgot_password_click" })
                      }
                    >
                      Forgot Password
                    </Link>
                  </div>
                )} */}
              </div>
            );
          }
        )}
        {error?.other && (
          <div className="text-[#f00] text-xs mb-1 ml-4">{error?.other}</div>
        )}

        <div className="flex flex-col gap-4 col-md-12">
          <div className="">
            <Button
              version="secondary"
              text="Sign In"
              type="submit"
              loading={loading}
            />
          </div>
          <div className="text-lg flex flex-wrap gap-x-2">
            <p className="font-medium">Don’t have an account?</p>
            <Link
              to={`/register/${tabName || "school"}${isAiLab ? "?source=ai-lab" : ""}`}
              className="font-bold hover:underline cursor-pointer text-[#009DFF] hover:text-[#009DFF]"
              onClick={() => GAEventTrack({ event: "register_btn_click" })}
            >
              Register Now
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UserLogin;
